import CarouselItem from '@/components/molecules/slider/components/CarouselItem/CarouselItem';

export { default as CarouselItemTheme } from './CarouselItem.style';
export default CarouselItem;
